import React, { useState } from 'react';
import CKEditor from '@ckeditor/ckeditor5-react';
import CKEditorReach from 'ckeditor5-custom-build-reach';

function App() {
  const [data, setData] = useState("<p>Hello from CKEditor 5!</p>");

  function onCopy() {
    navigator.clipboard.writeText(data).then(() => {
      alert("Copied the text: " + data);
    }).catch(() => {
      alert("Failed to copy the text, sorry! Please do it manually :(");
    })
  }

  return (
    <>
      <div>
        <div>
          <h1>-- Editor --</h1>
          <button style={{ marginBottom: "1em", padding: "1em", backgroundColor: "#FFBC00" }} onClick={onCopy}>Copy generated HTML</button>
        </div>
        <div>
          <CKEditor
            editor={ CKEditorReach }
            data={data}
            onInit={ editor => {
              // You can store the "editor" and use when it is needed.
              console.log( 'Editor is ready to use!' );
            } }
            onChange={ ( event, editor ) => {
              const dataChanged = editor.getData();
              setData(dataChanged);
            } }
          />
        </div>
      </div>
      <div>
        <h2>-- Generated HTML --</h2>
        <pre style={{ whiteSpace: "pre-wrap" }}>
          {data}
        </pre>
      </div>
    </>
  );
}

export default App;
